import get from 'lodash.get';
import config from '../configuration/config';
import type { State, RootState } from '../types/store';

function getSubscriptionManagerState(rootState: RootState): State {
  const statePath = config.getStatePath();

  if (!statePath) {
    return rootState || {};
  }

  return get(rootState, statePath, {});
}

export default getSubscriptionManagerState;
